import { handleActions } from 'redux-actions'

import * as actions from './actions'

const initialState = {
  isOpen: false
}

export const pauseDeflectionModalReducer = handleActions(
  {
    [actions.openPauseDeflectionModal]: () => {
      return {
        isOpen: true
      }
    },
    [actions.closePauseDeflectionModal]: () => {
      return {
        isOpen: false
      }
    }
  },
  initialState
)
